module.exports = __webpack_public_path__ + "static/panels-2-a92c095db86558198d29429d6c2b2642.png";